import React from 'react';
import styled from 'styled-components';
import { prop } from 'styled-tools';
import { SCAFFOLDING } from 'theme';

const StyledMapWrapperOuter = styled.div`
    display: inline-block;
    position: relative;
    width: ${prop('width')};
    height: ${prop('height')};
    margin: auto;
    overflow: hidden;
    box-shadow: ${SCAFFOLDING.BOX_SHADOW.BASE};
`;

const MapWrapperOuter = ({ width, height, children, ...props }) => {
    return (
        <StyledMapWrapperOuter width={width} height={height} {...props}>
            {children}
        </StyledMapWrapperOuter>
    );
};

export default MapWrapperOuter;
